var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('choose-scenario',{attrs:{"cardName":_vm.elementIds.UsernameChooseScenarioCard}})}
var staticRenderFns = []

export { render, staticRenderFns }